export default __webpack_public_path__ + "static/media/profile01.aed449ed.jpg";